import script from "./FormCodeEditorField.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormCodeEditorField.vue?vue&type=script&lang=ts&setup=true"

import "./FormCodeEditorField.vue?vue&type=style&index=0&id=6cecffb2&lang=css"

const __exports__ = script;

export default __exports__